<template>
  <div class="home">
    <div class="search-bar">
      <van-search
        v-model="searchQuery"
        placeholder="搜索网盘资源"
        shape="round"
        background="#1989fa"
        @search="onSearch"
      />
      <div class="drive-filter">
        <van-tag
          v-for="drive in driveTypes"
          :key="drive.value"
          :type="selectedDrive === drive.value ? 'primary' : 'default'"
          @click="selectDrive(drive.value)"
          class="drive-tag"
        >
          {{ drive.label }}
        </van-tag>
      </div>
    </div>

    <div class="ranking-section">
      <div class="section-header">
        <span class="title">热门短剧排行榜</span>
      </div>

      <van-loading v-if="loading" class="loading" />

      <div class="resource-list">
        <div
          v-for="item in displayList"
          :key="item.id"
          class="resource-item"
        >
          <div class="item-cover" @click.stop="searchByTitle(item.title)">
            <img v-if="item.src" :src="item.src" :alt="item.title" />
            <div v-else class="cover-placeholder">
              <van-icon name="image" size="32" />
            </div>
          </div>
          <div class="item-info" @click="openLink(item.shareLink)">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-desc">{{ item.desc }}</div>
            <div class="item-meta">
              <van-tag size="small" type="success">{{ item.drive }}</van-tag>
              <span class="category" v-if="item.category">{{ item.category }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="load-more" v-if="hasMore && !loading" @click="goToMore">
        <span>查看更多</span>
        <van-icon name="arrow-down" />
      </div>

      <div v-if="!loading && list.length === 0" class="empty">
        暂无数据
      </div>
    </div>
  </div>
</template>

<script>
import { getRanking } from '../utils/api';

export default {
  name: 'Home',
  data() {
    return {
      searchQuery: '',
      selectedDrive: '',
      driveTypes: [
        { label: '全部', value: '' },
        { label: '夸克', value: 'quark' },
        { label: '百度', value: 'baidu' },
        { label: '阿里', value: 'ali' }
      ],
      list: [],
      displayList: [],
      loading: false,
      hasMore: true
    };
  },
  mounted() {
    this.fetchRanking();
  },
  methods: {
    async fetchRanking() {
      this.loading = true;
      try {
        const res = await getRanking({ channel: '短剧', limit: 120 });
        if (res.code === 0 && res.data) {
          this.list = res.data.list || [];
          this.displayList = this.list.slice(0, 30);
          this.hasMore = this.list.length > 30;
        }
      } catch (error) {
        this.$toast('加载失败');
      } finally {
        this.loading = false;
      }
    },
    onSearch() {
      if (!this.searchQuery.trim()) {
        this.$toast('请输入搜索关键字');
        return;
      }
      this.$router.push({
        path: '/search',
        query: { q: this.searchQuery, drive: this.selectedDrive }
      });
    },
    searchByTitle(title) {
      this.$router.push({
        path: '/search',
        query: { q: title, drive: this.selectedDrive }
      });
    },
    selectDrive(drive) {
      this.selectedDrive = drive;
    },
    openLink(url) {
      if (url) {
        location.href = url;
      }
    },
    goToMore() {
      this.$router.push({
        path: '/ranking-more',
        query: { channel: '短剧' }
      });
    }
  }
};
</script>

<style scoped>
.home {
  min-height: 100vh;
  background: #f5f5f5;
}

.search-bar {
  background: #1989fa;
  position: sticky;
  top: 0;
  z-index: 100;
}

.drive-filter {
  display: flex;
  gap: 8px;
  padding: 8px 12px;
  background: #fff;
  overflow-x: auto;
}

.drive-tag {
  flex-shrink: 0;
  cursor: pointer;
}

.ranking-section {
  padding: 12px;
}

.section-header {
  margin-bottom: 12px;
}

.section-header .title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.loading {
  text-align: center;
  padding: 20px;
}

.resource-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
}

.resource-item {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.item-cover {
  width: 100%;
  aspect-ratio: 3 / 4;
  background: #f0f0f0;
  cursor: pointer;
  position: relative;
}

.item-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cover-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ccc;
}

.item-info {
  padding: 10px;
  cursor: pointer;
}

.item-title {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-desc {
  font-size: 11px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 4px;
}

.item-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
}

.category {
  font-size: 11px;
  color: #999;
}

.load-more {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 12px;
  background: #fff;
  border-radius: 8px;
  margin-top: 12px;
  color: #1989fa;
  cursor: pointer;
}

.empty {
  text-align: center;
  padding: 40px;
  color: #999;
}
</style>
